export default {
      id: "support-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#support",
      toString: function () {
        return this.url;
      }
    }